<div class="flex ninety-dialog-header">
  <h2 mat-dialog-title class="flex1">Send to another team</h2>
  <ninety-button flat mat-dialog-close ariaLabel="Close" class="right-space-15">
    <terra-icon icon="x" size="20" />
  </ninety-button>
</div>

<mat-dialog-content class="send-to-team-dialog__form">
  <terra-form-field>
    <terra-form-label>Team</terra-form-label>
    <terra-select
      [formControl]="teamControl"
      placeholder="Select a team..."
      aria-label="Team"
      maxHeight="350"
      maxWidth="450"
      required>
      <terra-select-search>
        <terra-search-input [formControl]="teamSearchTerm" />
      </terra-select-search>
      <ng-container *ngrxLet="teamSearchResults$ as teamSearchResults">
        @if (teamSearchTerm.value && teamSearchResults.length === 0) {
          <terra-description>
            No search results found. Please check your spelling or try a different search.
          </terra-description>
        }
        @for (team of data.teams | terraLazyOptions: '_id'; track team._id) {
          <terra-option
            [value]="team._id"
            [style.display]="team | terraVisibleSearchOption: teamSearchTerm.value : teamSearchResults">
            {{ team.name }}
          </terra-option>
        }
      </ng-container>
    </terra-select>
  </terra-form-field>

  <terra-form-field optional>
    <terra-form-label>Comment</terra-form-label>
    <terra-multiline-input
      [formControl]="commentControl"
      placeholder="Share background context that the other team should know..."
      aria-label="Comment"
      minRows="3" />
  </terra-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <ninety-button mat-dialog-close secondary stroked>Cancel</ninety-button>
  <ninety-button filled primary color="accent" [disabled]="!teamControl.value" (click)="send()">
    <terra-icon icon="send" size="20" />
    Send
  </ninety-button>
</mat-dialog-actions>
